module.exports = __webpack_public_path__ + "img/tripadvisor.bb514d26.svg";